angular.
module("dx.webapp.exam").
component("dxEditExternalToolSettings", {
	bindings: {
		externalTool: "<",
		originalSettings: "<settings",
		saveExternalToolSettings: "<onSave",
		rightToLeft: "<",
	},
	templateUrl: "tmpl/external-tool/edit-external-tool-settings-component/edit-external-tool-settings-component.html",
	controller: "DxEditExternalToolSettingsController",
	controllerAs: "vm",
});
